import { isCancel } from '@studio/api/api-client/is-cancel';

const isAbortLikeError = (error: unknown): boolean =>
  isCancel(error) || (error instanceof Error && error.name === 'AbortError');

export default isAbortLikeError;
